<template>
  <div id="app"  >
	<vue-headful
        title="LABORATOIRE-NATIVE"
        description=""
    />
    <div class="main">
		<navigation/>
		<div class="main-container">
			<router-view/>
		</div>
	</div>
    <sqreen-footer :class="{'absoluteFooter':vw > 990 && $route.path == '/' && !isAuthenticated}"/>
  </div>
</template>
<style lang="css" scoped>
  @import'~bootstrap/dist/css/bootstrap.min.css';
</style>
<script>
import Navigation from 'components/navigation'
 import { mapGetters, mapState } from 'vuex'
import { USER_REQUEST } from 'actions/user'
import SqreenFooter from './components/footer/index.vue'
import "./assets/scss/main.scss";
export default {
  components: {
    SqreenFooter,
    Navigation,
	//loading,
  },
  name: 'app',
  data () {
      return {
				moment: require('moment'),
				vh: window.innerHeight,
				vw: window.innerWidth,
      }
    },
  created: function () {
    if (this.$store.getters.isAuthenticated) {
      
      this.$store.dispatch(USER_REQUEST)
    }
  },
  mounted(){
		window.onresize = () => {
				this.vw = window.innerWidth
				this.vh = window.innerHeight
		}
	},
  computed: {
      ...mapGetters(['getProfile', 'loginerror', 'loadingState', 'isAuthenticated', 'isProfileLoaded', 'authStatus', 'checkAge' ]),
      ...mapState({
      })
    },
}
</script>



// WEBPACK FOOTER //
// src/App.vue